<template>
  <div
    v-if="visible && respuestasFiltradas.length > 0"
    class="wa-quick-replies-popup"
    @click.stop
  >
    <div class="wa-qr-header d-flex justify-content-between align-items-center">
      <span>
        <i class="mdi mdi-lightning-bolt text-warning me-1"></i> Respuestas Rápidas
      </span>
      <span class="font-size-11 text-muted">Usa ↑ ↓ Enter o clic</span>
    </div>
    <div class="wa-qr-list">
      <div
        v-for="(r, idx) in respuestasFiltradas"
        :key="r.id || idx"
        class="wa-qr-item"
        :class="{ 'is-selected': indiceInterno === idx }"
        @click="seleccionar(r)"
        @mouseenter="indiceInterno = idx"
      >
        <div class="d-flex justify-content-between align-items-center">
          <span class="wa-qr-item-title">{{ r.titulo }}</span>
          <span class="wa-qr-item-badge">/{{ r.atajo }}</span>
        </div>
        <div class="wa-qr-item-preview">
          {{ previsualizar(r.mensaje) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SitioSrv from "@/services/SitioSrv.js";
import { RESPUESTAS_RAPIDAS_PREDETERMINADAS } from "@/views/sistema/ajustesSistema/whatsappBusiness/CmpRespuestasRapidasWhatsapp.vue";

export default {
  name: "CmpRespuestasRapidasChat",
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    filtro: {
      type: String,
      default: ""
    },
    indiceSeleccionado: {
      type: Number,
      default: 0
    },
    chatSeleccionado: {
      type: Object,
      default: null
    }
  },
  emits: ["update:indiceSeleccionado", "seleccionar", "cerrar"],
  data() {
    return {
      indiceInterno: 0,
      respuestasRapidas: JSON.parse(JSON.stringify(RESPUESTAS_RAPIDAS_PREDETERMINADAS))
    };
  },
  computed: {
    modelIndice() {
      return this.indiceInterno;
    },
    totalResultados() {
      return this.respuestasFiltradas.length;
    },
    respuestasFiltradas() {
      const lista = this.respuestasRapidas || [];
      const f = (this.filtro || "").trim().toLowerCase();
      if (!f) return lista;
      return lista.filter((r) => {
        const atajo = String(r.atajo || "").toLowerCase();
        const titulo = String(r.titulo || "").toLowerCase();
        const msg = String(r.mensaje || "").toLowerCase();
        return atajo.includes(f) || titulo.includes(f) || msg.includes(f);
      });
    }
  },
  watch: {
    filtro() {
      this.indiceInterno = 0;
    },
    indiceSeleccionado(nuevoIdx) {
      if (typeof nuevoIdx === "number") {
        this.indiceInterno = nuevoIdx;
      }
    },
    visible(estaVisible) {
      if (estaVisible) {
        if (!this.respuestasRapidas || this.respuestasRapidas.length === 0) {
          this.cargarAjustesRespuestasRapidas();
        }
      }
    }
  },
  mounted() {
    this.recuperarRespuestasDeCache();
  },
  methods: {
    cargarAjustesRespuestasRapidas() {
      SitioSrv.obtenerRespuestasRapidasWhatsapp()
        .then((response) => {
          if (Array.isArray(response.data) && response.data.length > 0) {
            this.respuestasRapidas = response.data;
            localStorage.setItem("argusblack.ajustes_whatsapp_respuestas_rapidas", JSON.stringify(response.data));
            return;
          }
          this.recuperarRespuestasDeCache();
        })
        .catch(() => {
          this.recuperarRespuestasDeCache();
        });
    },
    recuperarRespuestasDeCache() {
      try {
        const raw = localStorage.getItem("argusblack.ajustes_whatsapp_respuestas_rapidas");
        if (raw) {
          const parsed = JSON.parse(raw);
          if (Array.isArray(parsed) && parsed.length > 0) {
            this.respuestasRapidas = parsed;
            return;
          }
        }
      } catch (e) {
        console.warn("Error al leer cache local de respuestas rapidas:", e);
      }
      this.respuestasRapidas = JSON.parse(JSON.stringify(RESPUESTAS_RAPIDAS_PREDETERMINADAS));
    },
    previsualizar(texto) {
      if (!texto) return "";
      return this.reemplazarVariablesEnTexto(texto);
    },
    alCambiarFiltro(nuevoFiltro) {
      this.indiceInterno = 0;
    },
    seleccionarActual() {
      if (this.respuestasFiltradas.length === 0) return false;
      const r = this.respuestasFiltradas[this.indiceInterno] || this.respuestasFiltradas[0];
      if (r) {
        this.seleccionar(r);
        return true;
      }
      return false;
    },
    moverSeleccion(delta) {
      if (!this.visible || this.respuestasFiltradas.length === 0) return;
      const total = this.respuestasFiltradas.length;
      let nuevo = this.indiceInterno + delta;
      if (nuevo < 0) nuevo = total - 1;
      if (nuevo >= total) nuevo = 0;
      this.indiceInterno = nuevo;
      this.$emit("update:indiceSeleccionado", nuevo);
    },
    seleccionar(respuesta) {
      if (!respuesta) return;
      const procesado = this.reemplazarVariablesEnTexto(respuesta.mensaje || "");
      this.$emit("seleccionar", procesado);
    },
    reemplazarVariablesEnTexto(texto) {
      if (!texto || typeof texto !== "string") return "";
      const chat = this.chatSeleccionado || {};
      const cliente = chat.cliente || {};
      const empresa = (this.$store && this.$store.state.todo && this.$store.state.todo.nombre_empresa) || "ArgusBlack";

      const nombre = cliente.nombre || chat.nombre || "";
      const apPaterno = cliente.apellido_paterno || "";
      const apMaterno = cliente.apellido_materno || "";
      const nombreCompleto = (cliente.nombre_completo || `${nombre} ${apPaterno} ${apMaterno}`).trim() || nombre || "Cliente";

      const diccionario = {
        "{{nombre_empresa}}": empresa,
        "{{nombre_completo}}": nombreCompleto,
        "{{nombre}}": nombre || nombreCompleto,
        "{{apellido_paterno}}": apPaterno,
        "{{apellido_materno}}": apMaterno,
        "{{rfc}}": cliente.rfc || "-",
        "{{correo_electronico}}": cliente.correo || "-",
        "{{calle}}": cliente.calle || "-",
        "{{colonia}}": cliente.colonia || "-",
        "{{codigo_postal}}": cliente.codigo_postal || "-",
        "{{numero_ticket}}": "-",
        "{{fecha_registro}}": "-",
        "{{hora_registro}}": "-",
        "{{monto}}": "$0.00",
        "{{pago}}": "$0.00",
        "{{cambio}}": "$0.00",
        "{{metodo_pago}}": "Efectivo",
        "{{cajero}}": "-",
        "{{saldo_pendiente}}": "$0.00",
        "{{saldo_total}}": "$0.00",
        "{{fecha_limite}}": cliente.fecha_limite || cliente.fecha_corte || "-",
        "{{enlace_pago}}": cliente.enlace_pago || `${window.location.origin}/portal/pagos`
      };

      let resultado = texto;
      Object.keys(diccionario).forEach((tag) => {
        const val = diccionario[tag] !== null && diccionario[tag] !== undefined ? String(diccionario[tag]) : "";
        resultado = resultado.split(tag).join(val);
      });

      return resultado;
    }
  }
};
</script>
